import { io } from 'socket.io-client';

const WS_URL = process.env.REACT_APP_WS_URL || 'http://localhost:8080';

class SocketService {
  constructor() {
    this.socket = null;
    this.listeners = new Map();
  }

  connect() {
    if (this.socket?.connected) return;

    this.socket = io(`${WS_URL}/auctions`, {
      transports: ['websocket', 'polling'],
      reconnection: true,
      reconnectionDelay: 1000,
      reconnectionAttempts: 10,
    });

    this.socket.on('connect', () => {
      console.log('WebSocket connected');
    });

    this.socket.on('disconnect', (reason) => {
      console.log('WebSocket disconnected:', reason);
    });
  }

  disconnect() {
    if (this.socket) {
      this.socket.disconnect();
      this.socket = null;
    }
  }

  // Subscribe to a listing's bid updates
  joinListing(listingId) {
    this.socket?.emit('joinListing', { listingId });
  }

  leaveListing(listingId) {
    this.socket?.emit('leaveListing', { listingId });
  }

  // Subscribe to personal notifications (auction won, payment, etc.)
  joinUser(userId) {
    this.socket?.emit('joinUser', { userId });
  }

  // Listen for events
  on(event, callback) {
    this.socket?.on(event, callback);
    // Track for cleanup
    if (!this.listeners.has(event)) {
      this.listeners.set(event, []);
    }
    this.listeners.get(event).push(callback);
  }

  off(event, callback) {
    this.socket?.off(event, callback);
  }

  // Clean up all listeners
  removeAllListeners() {
    this.listeners.forEach((callbacks, event) => {
      callbacks.forEach(cb => this.socket?.off(event, cb));
    });
    this.listeners.clear();
  }
}

const socketService = new SocketService();
export default socketService;
